import { faTable } from '@fortawesome/pro-regular-svg-icons'
import { SectionWrapper } from '../SectionWrapper/SectionWrapper'
import { MetaData } from '../../../types/flyout'
import { useStyles } from './CustomMetaDataView.styles'
import { DetailInfo, DetailRow } from '../DetailRow/DetailRow'
import { ViewValueWithTruncate } from '@labrav/common'

export const CustomMetaDataView = ({ metaData }: { metaData: MetaData[] }) => {
  const { classes } = useStyles()
  return (
    <SectionWrapper heading="Custom metadata" icon={faTable}>
      <div className={classes.sectionContent}>
        {metaData?.map((metaDataItem, index) => (
          <DetailRow
            key={`metaData-${metaDataItem?.key ?? index}`}
            borderBottom
          >
            <>
              <DetailInfo
                title="Key"
                value={<ViewValueWithTruncate value={metaDataItem?.key} />}
                keyName="cloudOfferId"
              />
              <DetailInfo
                title="Value"
                value={
                  <ViewValueWithTruncate value={metaDataItem?.value || ''} />
                }
                keyName="labraOfferId"
              />
            </>
          </DetailRow>
        ))}
      </div>
    </SectionWrapper>
  )
}
